import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import JwtService from '@/common/jwt.service';
import { REFRESH_TOKEN_URL } from '@/constants/ApiConstants';
import STATUS_CODES from '@/common/statusCodes';
import store from './../store'; // path to your Vuex store
import router from '@/router'



const ApiService = {
  init () {
    Vue.use(VueAxios, axios);
    this.setHeader();

    Vue.axios.interceptors.request.use(config => {
      const layoutWrapper = document.getElementsByClassName('layout-wrapper');
      
      if(layoutWrapper.length) {
        layoutWrapper[0].classList.add('loading');
      }
      
      return config;
    });

    Vue.axios.interceptors.response.use(({ data }) => {
      let layoutWrapper = document.getElementsByClassName('layout-wrapper');

      if(layoutWrapper.length) {
        layoutWrapper[0].classList.add('loaded');

        setTimeout(() => {
          layoutWrapper[0].classList.remove('loaded');
          layoutWrapper[0].classList.remove('loading');
        }, 200);
      }

      return data
    }, error => {
      const originalRequest = error.config;
      const layoutWrapper = document.getElementsByClassName('layout-wrapper');

      if (error.response && error.response.status === 401 && error.response.data.status.code === STATUS_CODES.BP_403 && error.response.data.status.desc.includes("SignatureException")) {
        store.dispatch('LOGOUT')
        router.push({name: 'Login'})
      }
      
      if (error.response && error.response.status === 401 && error.response.data.status.code === STATUS_CODES.BP_405) {
        originalRequest._retry = true

        const refreshToken = JwtService.getRefreshToken()

        return axios.post(REFRESH_TOKEN_URL, { refreshToken })
          .then(({data}) => {
            JwtService.saveToken(data.accessToken)
            JwtService.saveRefreshToken(data.refreshToken)
            originalRequest.headers['Authorization'] = `Bearer ${data.accessToken}`;
            this.setHeader()

            return axios(originalRequest)
          })
      }

      if(layoutWrapper.length) {
        layoutWrapper[0].classList.add('loaded');

        setTimeout(() => {
          layoutWrapper[0].classList.remove('loaded');
          layoutWrapper[0].classList.remove('loading');
        }, 200);
      }

      return Promise.reject(error.response ? error.response.data : error)
    })
  },

  setHeader () {
    let jwtToken = JwtService.getToken()

    if (jwtToken) {
      Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`
    }
  },

  removeTokenAuthHeader () {
    Vue.axios.defaults.headers.common['Authorization'] = ''
  },

  get (url, params) {
    return Vue.axios
      .get(url, { params })
  },

  post (url, params, contentType) {
    return Vue.axios.post(url, params, { 
      headers: { 'Content-Type': contentType || 'application/json' }
    })
  },

  postFormData (url, params) {
    return Vue.axios({
      method: 'post',
      url,
      data: params,
      config: {
        headers: {
          'Content-Type': undefined
        }
      }
    })
  },

  put (url) {
    return Vue.axios
      .put(url)
  },

  putData (url, params, contentType) {
    return Vue.axios
      .put(
        url, 
        params, 
        { 
          headers: { 'Content-Type': contentType || 'application/json' }
        })
  },

  putFormData (url, params) {
    return Vue.axios({
      method: 'put',
      url,
      data: params,
      config: {
        headers: {
          'Content-Type': undefined
        }
      }
    })
  },

  delete (url) {
    return Vue.axios
      .delete(url)
      .catch((error) => {
        throw new Error(`[Error] ApiService ${error}`)
      })
  },

  patch (url, params) {
    return Vue.axios
      .patch(url,  params )
  },
}

export default ApiService
